// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_7x-3";
export var contentContainer = "_7x-0";
export var editorContainer = "_7x-1";
export var quillInputForm = "_7x-2";
export var zoneDivider = "_7x-4";